import React, { useRef } from "react";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { CiMenuKebab } from "react-icons/ci";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { HiOutlineRefresh } from "react-icons/hi";

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CustomTab({
  tabs,
  initialIndex = 0,
  onTabChange,
  changeTab = () => {},
  sx,
  refresh,
  setRefresh,
  setChangeUnreadMessageState,
  changeUnreadMessageState,
  setUnreadMsgRefresh = () => {},
} = {}) {
  const theme = useTheme();
  const [value, setValue] = React.useState(initialIndex);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const prevValueRef = useRef(null);

  const handleChange = (event, newValue) => {
    prevValueRef.current = value;
    if (newValue == 3) {
      if (value == 1) {
        setValue(1);
        changeTab(1);
        setRefresh(!refresh);
        return;
      }
      setValue(0);
      changeTab(0);
      setRefresh(!refresh);
      return;
    } else if (newValue == 2) {
      setChangeUnreadMessageState(true);
      // if i want to unread every time
      // setChangeUnreadMessageState(Date.now());
      setUnreadMsgRefresh(true);
      if (value == 1) {
        changeTab(1);
        setValue(1);
        return;
      } else {
        changeTab(0);
        setValue(0);
        return;
      }
      // setAnchorEl(null);
    }
    setValue(newValue);
    changeTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  function handleMenuItem(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    // setChangeUnreadMessageState(true);
    // // if i want to unread every time
    // // setChangeUnreadMessageState(Date.now());
    // changeTab(2);
    // setAnchorEl(null);
    // setUnreadMsgRefresh(true)
    setAnchorEl(null);
  }

  function handleClick() {
    setChangeUnreadMessageState(true);
    // if i want to unread every time
    // setChangeUnreadMessageState(Date.now());
    changeTab(2);
    setAnchorEl(null);
    setUnreadMsgRefresh(true);
  }

  return (
    <Box sx={{ bgcolor: "background.paper", width: "100%", ...sx }}>
      <AppBar
        position="sticky"
        sx={{
          boxShadow: "none",
          backgroundColor: "white",
          top: 50,
          zIndex: 1000,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          variant="fullWidth"
          aria-label="customizable tabs"
          TabIndicatorProps={{ style: { backgroundColor: "inherit" } }}
          sx={{
            backgroundColor: "white",
            boxShadow: "none",
            borderBottom: "none",
            flexDirection: { xs: "column", sm: "column", lg: "row" },
            "& .MuiTabs-flexContainer": {
              flexDirection: { xs: "column", sm: "column", lg: "row" },
              boxShadow: "none",
              borderBottom: "none",
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              {...a11yProps(index)}
              sx={{
                flexGrow: index === 3 ? 0 : 1,
                // minWidth: {
                //   xs: index === 3 ? "100%" : "40%", // Full width for 3rd tab on small screens
                //   lg: index === 3 ? "15%" : "40%", // Revert to original on larger screens
                // },
                minWidth: {
                  xs: index === 3 ? "100%" : index == 2 ? "30%" : "30%", // Full width for 3rd tab on small screens
                  lg: index === 3 ? "15%" : index == 2 ? "25%" : "30%", // Revert to original on larger screens
                },
                maxWidth: index === 3 ? "10%" : "none",
                fontSize: "13px",
                fontWeight: "500",
                textTransform: "none",
                padding: "2px 4px", // reduce padding
                minHeight: "40px", // reduce height
                lineHeight: "1.2", // tighter vertical spacing
                borderRadius: "5px",
                marginLeft: index == 2 && "2px",
                color: value === index ? "white" : "black",
                backgroundColor: value === index ? "#63BE5F" : "white",
                boxShadow: "none",
                border: "none",
                "&:hover": {
                  backgroundColor: index == 2 && "#63BE5F",
                  color: index == 2 && "white !important" ,
                },
                "&.Mui-selected": {
                  color: "white",
                },
                "&:not(.Mui-selected)": {
                  color: "black",
                },
                "&.MuiTab-root": {
                  opacity: 1,
                },
              }}
            />
          ))}
          {/* <div className="w-20 flex justify-center items-center">
            <CiMenuKebab
              size={20}
              color="black"
              className="absolute top-[18px] right-0 w-6"
              onClick={handleMenuItem}
            />
            <div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem  onClick={handleClick}>
                  <HiOutlineRefresh />
                </MenuItem>
              </Menu>
            </div>
          </div> */}
        </Tabs>
      </AppBar>

      {tabs.map((tab, index) => (
        <TabPanel key={index} value={value} index={index} dir={theme.direction}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
}

CustomTab.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  initialIndex: PropTypes.number,
  onTabChange: PropTypes.func,
  sx: PropTypes.object,
};
